module.exports = __webpack_public_path__ + "media/images/pear_4-76f6c94a2cff385e8f591c05de7cf8ee.jpg";